import { SceneData } from 'src/utils/types/scene';

import { Scenes } from '../../utils/enums/scenes';
import { WithScoreScene } from '../classes/WithScoreScene';
import { UI } from '../ui/ui';

export class Score extends WithScoreScene {
  constructor() {
    super(Scenes.SCORE);
  }

  init(data: SceneData): void {
    this.user = data.user;
  }

  create(): void {
    this.setupUI();
    this.setupButtons();
    this.scene.stop(Scenes.LOADING);
  }

  update(): void {
    this.updateTopPlayersUi();
  }

  private setupUI(): void {
    UI.images.Background(this);
    UI.text.HighScores(this);
    this.topPlayersUi = UI.components.TopPlayers(this);
    UI.icons.FullScreenIcon(this);
  }

  private setupButtons(): void {
    UI.buttons.ScorePlayBtn(this, () => {
      this.handleNavigation(Scenes.GAME);
    });

    UI.icons.HomeIcon(this, { interactive: true }).on('pointerdown', () => {
      this.handleNavigation(Scenes.EXIT_GAME);
    });
  }

  private handleNavigation(targetScene: string): void {
    this.scene.stop();
    this.resetApiFlags();
    this.scene.start(targetScene, { user: this.user });
  }
}
